import { Avatar } from 'primereact/avatar';
import style from '../../../views/employee.module.css';

type Props = {
	messages: Message[];
};

type Message = {
	id: number;
	text: string;
	sender: string;
	timestamp: Date;
	isUser: boolean;
};

const Messages = (props: Props) => {
	const { messages } = props;

	const formatDate = (date: Date) => {
		return new Intl.DateTimeFormat('en-US', {
			weekday: 'short',
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			hour12: true,
		}).format(date);
	};

	return (
		<div className="flex flex-col">
			<div className="flex-1 space-y-6">
				{messages.length > 0 && (
					<div className="text-center text-body-xx-small my-2">
						{formatDate(messages[0].timestamp)}
					</div>
				)}

				{messages.map((message) => (
					<div
						key={message.id}
						className={`flex ${message.isUser ? 'justify-end' : 'justify-start'} items-end gap-3`}
					>
						{!message.isUser && (
							<Avatar
								label={message.sender}
								shape="circle"
								className={style.employeeAvatar}
							/>
						)}

						<div
							className={`rounded-[28px] text-title-small p-4 max-w-[70%] ${
								message.isUser
									? 'bg-primary60 text-white rounded-ee-none'
									: 'bg-surfaceContainerLower text-black rounded-es-none'
							}`}
						>
							{message.text}
						</div>

						{message.isUser && (
							<Avatar
								label={message.sender}
								shape="circle"
								className={style.employeeAvatar}
							/>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default Messages;
